import Box from '@mui/material/Box';
import logoDark from '../assets/logo-dark.svg';
import logoLight from '../assets/logo-light.svg';
import { useColorMode } from '../theme/colorMode';

export interface LogoProps {
  height?: number | string;
  width?: number | string;
}

/**
 * The one place the branding is wired up. Both assets are transparent; each relies on the theme's
 * surface behind it for contrast.
 */
export function Logo({ height = 30, width = 'auto' }: LogoProps) {
  const { resolvedMode } = useColorMode();

  return (
    <Box
      component="img"
      src={resolvedMode === 'dark' ? logoDark : logoLight}
      alt="AlgoBridge"
      sx={{ height, width, display: 'block' }}
    />
  );
}
